export default [
  { value: 'NI', label: 'Nicaragua' },
  { value: 'US', label: 'United States of America' },
];
